<template>
  <form @submit.prevent="submit">
    <Field
      label="Duplicate As"
      @input="$v.resource.name.$touch()"
      v-model="resource.name"
      helpText="Internal use only (e.g. Reviews List New)"
      :error="nameError"/>

    <Field
      label="To..."
      type="select"
      :options="allPages"
      @input="$v.resource.pageId.$touch()"
      v-model="resource.pageId"
      helpText="What page would you like to duplicate this to?"
      :error="pageIdError"/>

    <Btn :isLoading="isLoading" primary>Duplicate</Btn>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'DuplicateListForm',

  mixins: [form],

  components: {
    Btn
  },

  props: {
    pages: {
      type: Array,
      required: true
    },

    list: {
      type: Object
    },

    isLoading: {
      type: Boolean
    }
  },

  computed: {
    ...errorMessages(['name', 'pageId']),

    allPages() {
      let newPages = []

      this.pages.forEach((page) => {
        newPages.push({key: page.name, value: page.id})
      })

      return newPages
    }
  },

  validations: {
    resource: {
      name: {required},
      pageId: {required}
    }
  }
}
</script>
